<template>

  <div class="bg-dimmed onboarding-content">
    <v-icon class="secondary--text">{{ page.icon }}</v-icon><!-- eslint-disable vue/no-v-html -->
    <div class="secondary--text header" v-html="page.header"/><!-- eslint-enable -->

    <div v-if="page.html"
         class="text"
         v-html="page.html">&nbsp;
    </div>

    <div v-else
         class="text">{{ page.text }}
    </div>
  </div>


</template>
<script>
export default {
  props: {
    page: {
      type: Object,
      required: true
    }
  }
};
</script>
<style>
.onboarding-content {
  width: 100%;
  max-width: 448px;
  min-height: 382px;
  margin: 0 auto;
  padding: 40px;
  text-align: center;
}

.onboarding-content .v-icon {
  font-size: 56px;
}

.onboarding-content .header {
  font-size: 20px !important;
  font-weight: 400;
  margin: 36px auto 24px auto;
}

.onboarding-content .text {
  text-align: center;
  font-size: 14px;
}
</style>
